import {ProductService} from "@/common/api/product.service";
import {
    PRODUCT_GET,
    PRODUCT_BRAND_SEARCH,
    PRODUCTS_GET,
    PRODUCT_CREATE,
    PRODUCT_UPDATE,
    PRODUCTS_SIMPLE_GET,
    PRODUCT_UPDATE_STOCK,
    PRODUCT_SEARCH,
    PRODUCT_ACTIVE,
    PRODUCT_INACTIVE,
    PRODUCT_DELETE,
    PARAMETERS_GET, PRODUCT_SEARCH_SIMPLE
} from "./actions/product.type";
import {CHANGE_PROGRESS} from "./mutations/mutations.type"
import {
    SET_PRODUCT,
    SET_PRODUCTS,
    SET_CLASSES,
    SET_CATEGORIES,
    SET_PACKAGES,
    SET_UNITS,
    SET_BRANDS,
    SET_PRODUCTS_SIMPLE,
    SET_PRODUCT_PAGINATION,
    SET_PRODUCT_ACTIVE,
    PRODUCT_RESET_STATE
} from "./mutations/product.type";




const initialState = () => {
    return {
        product: {
            id: 0,
            classID: 0,
            class: "",
            unitID: 0,
            unit: "",
            packageID: 0,
            package: "",
            categoryID: 0,
            category: "",
            brandID: 0,
            brand: "",
            supplierID: 0,
            supplier: "",
            code: "",
            description: "",
            barCode: "",
            manufacturerCode: "",
            profitMargin: "",
            minimumStock: null,
            maximumStock: null,
            commissionBM: null,
            quantity: null,
            costPrice: null,
            salesPrice: null,
            status: 0
        },
        brands: [],
        productCategories: [],
        classes: [],
        packages: [],
        units: [],

        productPagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },
        
        products: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },
        productsSimple: []
    };
};

export const state = initialState();

const getters = {
    product: state => {
        return state.product;
    },
    products: state => {
        return state.products
    },
    productsSimple: state => {
        return state.productsSimple
    },
    productsInsumos: state => {
        return  state.productsSimple.filter(item => item.product_class_id === 1)
    },
    productCategories: state => {
        return state.productCategories
    },
    productPagination: state => {
      return state.productPagination  
    },
    brands: state => {
        return state.brands
    },
    classes: state => {
        return state.classes
    },
    packages: state => {
        return state.packages
    },
    units: state => {
        return state.units
    }
};

const mutations = {
    [SET_PRODUCT](state, data) {
        state.product = data;
        state.brads = [
            {
                id: data.brandID,
                name: data.brand
            }
        ]
    },
    [SET_PRODUCT_PAGINATION](state, data) {
        state.products.activePage = data.page
        state.productPagination.itemsPerPage = data.itemsPerPage
        state.productPagination.orderBy = data.orderBy
        state.productPagination.sortDesc = data.sortDesc
    },
    [SET_PRODUCTS](state, data) {
        state.products = data;
    },
    [SET_PRODUCTS_SIMPLE](state, data) {
        state.productsSimple = [...data];
    },
    [SET_CATEGORIES](state, data) {
        state.productCategories = data;
    },
    [SET_CLASSES](state, data) {
        state.classes = data;
    },
    [SET_PACKAGES](state, data) {
        state.packages = data;
    },
    [SET_UNITS](state, data) {
        state.units = data;
    },
    [SET_PRODUCT_ACTIVE](state, data) {
        state.product.active = data;
    },

    [SET_BRANDS](state, data) {
        state.brands = data;
    },
    [PRODUCT_RESET_STATE](state) {
        Object.assign(state, initialState());
    }
};

const actions = {
    async [PRODUCT_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProductService.get(id);
        commit(SET_PRODUCT, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCTS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProductService.list();
        commit(SET_PRODUCTS, data.items);
        commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCT_SEARCH]({commit, state}) {
        // commit(CHANGE_PROGRESS, true)
        const {data} = await ProductService.search(
            state.products.activePage,
            state.productPagination.itemsPerPage,
            state.products.active,
            state.productPagination.search,
            state.productPagination.orderBy,
            state.productPagination.sortDesc)
        commit(SET_PRODUCTS, data)
        // commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCTS_SIMPLE_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        let {data} = await ProductService.listSimple();
        
        if(data == null){
            data = []
        }
        
        commit(SET_PRODUCTS_SIMPLE, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCT_SEARCH_SIMPLE]({commit}, search) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProductService.searchSimple(search);
        commit(SET_PRODUCTS_SIMPLE, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCT_BRAND_SEARCH]({commit}, search) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProductService.brandSearch(search);
        commit(SET_BRANDS, data);
        commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCT_CREATE]({state}) {
        let product = state.product
        product.barCode = product.barCode.replace(/\s/g, '');
        if (product.minimumStock == ""){
            product.minimumStock = 0
        }
        if (product.maximumStock == ""){
            product.maximumStock = 0
        }
        
        return ProductService.post("", product);
    },
    async [PRODUCT_UPDATE_STOCK](_, data) {
        return ProductService.updateStock("",data.id, data);
    },
    [PRODUCT_ACTIVE](_, id) {
        return ProductService.active(id)
    },
    [PRODUCT_INACTIVE](_, id) {
        return ProductService.inactive(id)
    },
    [PRODUCT_DELETE]({state}) {
        return ProductService.delete(state.product.id)
    },
    async [PARAMETERS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true);
        const {data} = await ProductService.get_parameters();
        commit(SET_CLASSES, data.classes);
        commit(SET_PACKAGES, data.packages);
        commit(SET_UNITS, data.units);
        commit(SET_CATEGORIES, data.categories);
        commit(CHANGE_PROGRESS, false)
    },
    async [PRODUCT_UPDATE]({state}) {
        let product = state.product
        product.barCode = product.barCode.replace(/\s/g, '');
        if (product.minimumStock == ""){
            product.minimumStock = 0
        }
        if (product.maximumStock == ""){
            product.maximumStock = 0
        }

        return ProductService.update("", product);
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
